import { identity } from "ramda";

const metadataKey = `_DPS_META`;
const withMetaKey = e => `${e}${metadataKey}`;

export const createDBoxPluginStore = ($store) => (config = createDboxPluginStoreConfig(),) => {
  const nsGetter = `${config.storeNamesPace}/${config.detailsGetterKey}`;
  const detailsDict = $store.getters[nsGetter];
  if (!detailsDict) {
    return;
  }
  const selectedDetails =
    detailsDict[config.primaryKeyValue];

  const dboxData = $store.getters?.[nsGetter]?.[config.primaryKeyValue]?.[
    config.dataKey
  ];
  const dboxMetaData = $store.getters?.[nsGetter]?.[config.primaryKeyValue]?.[
    withMetaKey(config.dataKey)
  ];

  const updateDBoxStoreState = (updateFunc, metadataUpdateFunc = identity) => {
    $store.dispatch(
      `${config.storeNamesPace}/${config.detailsAction.SET.ALL}`,
      {
        ...detailsDict,
        [config.primaryKeyValue]: {
          ...selectedDetails,
          ...{
            [`${config.dataKey}`]: updateFunc(selectedDetails[
              config.dataKey
            ]),
            [withMetaKey(config.dataKey)]: metadataUpdateFunc(selectedDetails[
              withMetaKey(config.dataKey)
            ]),
          },
        },
      }
    );
  }
  const updateDBoxStoreData = (updateFunc = identity) => {
    $store.dispatch(
      `${config.storeNamesPace}/${config.detailsAction.SET.ALL}`,
      {
        ...detailsDict,
        [config.primaryKeyValue]: {
          ...selectedDetails,
          ...{
            ...dboxMetaData,
            [`${config.dataKey}`]: updateFunc(selectedDetails[
              config.dataKey
            ]),
          },
        },
      }
    );
  }
  const updateDBoxStoreMetaData = (metadataUpdateFunc = identity) => {
    $store.dispatch(
      `${config.storeNamesPace}/${config.detailsAction.SET.ALL}`,
      {
        ...detailsDict,
        [config.primaryKeyValue]: {
          ...selectedDetails,
          ...{
            ...dboxData,
            [withMetaKey(config.dataKey)]: metadataUpdateFunc(selectedDetails[
              withMetaKey(config.dataKey)
            ]),
          },
        },
      }
    );
  }

  return {
    dboxData,
    dboxMetaData,
    selectedDetails,
    updateDBoxStoreState,
    updateDBoxStoreData,
    updateDBoxStoreMetaData,
  };
}


export const createDboxPluginStoreConfig = ({
  storeNamesPace = 'CatalogStore',
  detailsAction = 'ProductDetails',
  detailsGetterKey = 'productDetails',
  dataKey = 'costs',
  primaryKeyValue = '12345',
  externalTable = "release",
}) => {
  return {
    storeNamesPace,
    detailsAction,
    detailsGetterKey,
    dataKey,
    primaryKeyValue,
    externalTable,
  }
}